<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="container space-top-1 space-top-sm-2">
  <div class="row mb-1">
    <div class="col-md-12">
      <div class="d-flex justify-content-start">
        <a [routerLink]="['../../', homeRoute]">
          <small class="fas fa-arrow-left mr-1"></small>
          Continue shopping
        </a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-7 mb-7 mb-lg-0">
      <div class="">
        <h1 class="h3 font-weight-medium">{{ product.title }}</h1>
        <div>{{ product.shortDescription }}</div>
      </div>

      <div [editorHTML]="product.description"></div>
      <!-- <div class="pr-lg-4">
        <div class="position-relative">
          <img class="img-fluid" src="/fetchimage?fileName={{ product.marketingSplash }}" [fallback]="'https://bxlimages.blob.core.windows.net/splash/noimage.png'"  />
        </div>
      </div> -->
    </div>

    <!-- Product Description -->
    <div class="col-lg-5">
      <!-- Rating -->

      <!-- Title -->

      <div class="row mb-2">
        <!-- <div class="col-md-5">
          <img class="img-fluid" src="/fetchimage?fileName={{ product.marketingSplash }}" [fallback]="'https://bxlimages.blob.core.windows.net/splash/noimage.png'"  />
        </div> -->
        <div class="col-md-12">
          <div class="mb-0">
            <h2 class="font-size-1 text-secondary font-weight-medium mb-0">Total price:</h2>
            <span class="font-size-2 font-weight-medium">{{ product.price | currency: conference.sponsorCurrency }}</span>
          </div>
          <div class="mb-5">
            <!-- End Title -->
            <span *ngIf="product.remainingQuantity >= 3" class="badge badge-success badge-pill">{{ product.remainingQuantity }} remaining</span>
            <span *ngIf="product.remainingQuantity < 3 && product.remainingQuantity != 0" class="badge badge-danger badge-pill">{{ product.remainingQuantity }} remaining</span>
          </div>
        </div>
      </div>
      <!-- Price -->

      <h6 *ngIf="product.addOns && product.addOns.length > 0 && product.addOnQuantity > 1">
        <strong>This product includes {{ product.addOnQuantity }} additional "variations" please choose your desired add-ons below.</strong>
      </h6>
      <h6 *ngIf="product.addOns && product.addOns.length > 0 && product.addOnQuantity == 1">
        <strong>This product includes {{ product.addOnQuantity }} additional "variation" please choose your desired add-on below.</strong>
      </h6>
      <div *ngFor="let item of [].constructor(product.addOnQuantity); let i = index" class="mb-5">
        <h2 class="font-size-1 text-secondary font-weight-medium mb-0">Add-On #{{ i + 1 }}:</h2>
        <select [(ngModel)]="selectedAddOns[i]" name="selectedAddOns" class="form-control">
          <option [ngValue]="addOn" *ngFor="let addOn of product.addOns">{{ addOn.title }} ({{ addOn.remainingQuantity }} Remaining)</option>
        </select>
        <div class="mt-1" *ngIf="selectedAddOns[i] && selectedAddOns[i].description" [editorHTML]="selectedAddOns[i].description"></div>
      </div>

      <h4 *ngIf="subProducts && subProducts.length > 0">Optional Add-Ons</h4>
      <ng-container *ngFor="let addon of subProducts; let i = index">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" [(ngModel)]="addon.selected" name="subProducts{{ i }}" id="customEventSwitch{{ i }}"/>
          <label class="custom-control-label" for="customEventSwitch{{ i }}">
            <span class="d-block">{{ addon.title }} (+{{ addon.price | currency }})</span>
            <small class="d-block text-muted">{{ addon.shortDescription }}</small>
          </label>
        </div>
        <!-- End Checkbox Switch -->

        <hr class="my-2"/>
      </ng-container>


      <div class="mb-4">
        <ng-container *ngIf="product.remainingQuantity > 0">
          <button *ngIf="!product.isBooth" type="button" (click)="addToCart()" class="btn btn-block btn-sm btn-outline-primary btn-sm-wide btn-pill transition-3d-hover">Add to Cart</button>
          <button *ngIf="product.isBooth" type="button" (click)="pickLocation()" class="btn btn-block btn-sm btn-outline-primary btn-sm-wide btn-pill transition-3d-hover">Pick Location</button>
        </ng-container>
        <button *ngIf="product.remainingQuantity == 0" type="button" disabled class="btn btn-block btn-sm btn-warning btn-sm-wide btn-pill">Sold Out</button>
        <!-- <button type="button" (click)="addToCart()" class="btn btn-block btn-primary btn-pill transition-3d-hover">Add to Cart</button> -->
      </div>

      <!-- Help Link -->

      <!-- End Help Link -->
    </div>
    <!-- End Product Description -->
  </div>
  <div class="row mt-3 mb-6">
    <div class="col-md-7">
      <img class="img-fluid" src="/fetchimage?fileName={{ product.marketingSplash }}" [fallback]="'https://bxlimages.blob.core.windows.net/splash/noimage.png'"/>
    </div>
  </div>
</div>
